export const checkIfHasHash = (docNo) => {
    return ['#DOCID', '#STATS'].some(hash => docNo.includes(hash));
}